<template>
  <div class="Logout">
    <div class="panel">
      <p v-if="isAuthenticated">
        Logging you out...
      </p>
      <div v-if="!isAuthenticated">
        <p>
          You have been logged out.
        </p>
        <p>
          <a href="/login">Login again</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  mounted() {
    this.$store.dispatch("logout");
  },

  computed: {
    ...mapGetters(['isAuthenticated'])
  },
};
</script>

<style lang="scss" scoped>
.Logout {
  display: grid;
  padding: 1em;
}

.panel {
  justify-self: center;
  align-self: center;
}
</style>
